<div class="total">
  <h3 class="label">
    <ng-content select="[title-total]" />
    @if (hasOnlinePayment() && !totalSubtitle()) {
    <span> <ng-content select="[label-total]" /> </span>
    }
    @if (totalSubtitle()) {
    <small class="label-subtitle">({{ totalSubtitle() }})</small>
    }
  </h3>
  <div class="prices">
    <span class="amount-pre_discount">{{ oldTotal() }}</span>
    <span id="totalPrice" class="amount">{{ total() }}</span>
  </div>
</div>
